(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

	ngModule.directive('storeOrderProductsTable', function ($Orders, $uibModal, $pageArray, $timeout, uiGridConstants, uiGridGroupingConstants) {
		return {
			scope: {
				store: '='
			},
			templateUrl: 'directives/storeOrderProductsTable/table.html',
			controller: function($scope) {

                $scope.init = function () {

                    $scope.gridOptions = {
                        columnDefs: [
                            // {
                            //     field: 'deleted',
                            //     displayName: 'Deleted',
                            //     width: "*"
                            // },
                            {
                                field: 'orderedBy',
                                displayName: 'Ordered By',
                                width: "*"
                            },
                            {
                                field: 'orderedFor',
                                displayName: 'Ordered For',
                                width: "*"
                            },
                            {
                                field: 'productName',
                                displayName: 'Product Name',
                                width: "*"
                            },
                            {
                                field: 'inPackage',
                                displayName: 'In Package',
                                width: "*"
                            },
                            {
                                field: 'sizes',
                                displayName: 'Size',
                                width: "*"
                            },
                            {
                                field: 'color',
                                displayName: 'Color',
                                width: "*"
                            },
                            {
                                field: 'options',
                                displayName: 'Options',
                                width: "*"
                            },
                            {
                                field: 'inseam',
                                displayName: 'Inseam',
                                width: "*"
                            },
                            {
                                field: 'fit',
                                displayName: 'Fit',
                                width: "*"
                            },
                            {
                                field: 'customName',
                                displayName: 'Custom Name',
                                width: "*"
                            },
                            {
                                field: 'customNumber',
                                displayName: 'Custom Number',
                                width: "*"
                            },
                            {
                                field: 'pricePerUnit',
                                displayName: 'Price Per Unit',
                                width: "*",
                                cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.pricePerUnit | currency}} </div>',
                            },
                            {
                                field: 'quantity',
                                displayName: 'Quantity',
                                width: "*"
                            },
                            {
                                field: 'orderID',
                                displayName: 'Order ID',
                                width: "*"
                            },
                            {
                                field: 'created',
                                displayName: 'Created',
                                width: "*"
                            },
                        ],
                        enableSorting: true,
                        enableColumnResizing: true,
                        enableFiltering: true,
                        showGridFooter: true,
                        showColumnFooter: true,
                        fastWatch: true,
                        enableGridMenu: true,
                        enableSelectAll: true,
                        exporterCsvFilename: $scope.store.name + '.csv',
                        exporterMenuPdf: false,
                        exporterCsvLinkElement: angular.element(document.querySelectorAll(".custom-csv-link-location")),
                        onRegisterApi: function(gridApi){
                          $scope.gridApi = gridApi;

                        //   $scope.gridApi.core.addRowHeaderColumn( { name: 'rowHeaderCol', displayName: '', width: 30, cellTemplate: '<div class="ui-grid-cell-contents"><a class="grid-anchor" ng-click="grid.appScope.selectOrder(row.entity)"><i class="fa fa-search"></i></a></div>' } );

                          $scope.gridApi.edit.on.afterCellEdit($scope,function(rowEntity, colDef, newValue, oldValue){
                              console.log('afterCellEdit', rowEntity, colDef, newValue, oldValue);
                            //$scope.msg.lastCellEdited = 'edited row id:' + rowEntity.id + ' Column:' + colDef.name + ' newValue:' + newValue + ' oldValue:' + oldValue ;
                            $scope.$apply();
                          });


                        },
                    };

                    $Orders.getStoreOrderedProducts($scope.store).then(function(products) {

                        $scope.gridOptions.data = products;

                    });

                };

                $scope.selectOrder = (order) => {

                    $uibModal.open({
                        animation: true,
                        templateUrl: 'directives/orderDetail/section.html',
                        windowTemplateUrl: 'directives/externalStore/fullScreenModalWindowTemplate.html',
                        controller: 'OrderDetailController',
                        resolve: {
                            orderDetails: function() {
                                return $Orders.getOrderByStore($scope.store.$id, order.orderId).then( (orderDetails) => {
                                    return orderDetails;
                                });
                            }
                        },
                        size: 'lg'
                    });

                };

                $scope.init();

                function readablePaymentMethod(paymentMethod) {

                    switch (paymentMethod) {
                        case 'credit':
                            return 'Credit Card';
                        case 'check':
                            return 'Check';
                        case 'org':
                            return 'School/Organization'
                        default:
                            break;
                    }

                };

			}
		};
	});

})();
